module.exports = __webpack_public_path__ + "assets/img/3-2.e9d2ec90.png";